import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=03ed8c34&scoped=true&"
import script from "./bar.vue?vue&type=script&lang=js&"
export * from "./bar.vue?vue&type=script&lang=js&"
import style0 from "./bar.vue?vue&type=style&index=0&id=03ed8c34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed8c34",
  null
  
)

export default component.exports